import React from 'react'
import useInput from 'tennders-common/form/hooks/useInput'

type Props = {
  errors ?: Record<string, any>,
  form ?: Record<string, any>,
  name ?: string,
  disabled ?: boolean,
  onChange ?: (key: string, value: any) => void,
  inputValue ?: any,
  renderInput?: (any) => JSX.Element
}

const OnlyInputContainer = (props: Props) => {
  const {
    errors,
    form,
    name,
    disabled,
    onChange,
    inputValue,
    renderInput
  } = props

  const { errorContent, errorText, value, onSet } = useInput({
    errors,
    form,
    name,
    onChange
  })

  return (
    <>
      {renderInput({ form, error: errorText, name, onSet, value, disabled })}
      {errorContent}
    </>
  )
}

export default React.memo<Props>(OnlyInputContainer)
